import { render, staticRenderFns } from "./ComplaintHistoryDetail.vue?vue&type=template&id=f2b57fe2&"
import script from "./ComplaintHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./ComplaintHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports